import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Banner = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 40px;
`;

export const Text = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    color: #040222;
    margin-top: 12px;
`;

export const SubText = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #5b5675;
    margin-top: 10px;
`;

export const Description = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #5b5675;
    margin-top: 16px;
    text-align: center;
`;

export const AvailableOn = styled.div`
    display: flex;
    margin-top: 40px;
    justify-content: center;
`;

export const AvailableOnText = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #5b5675;
    text-align: center;
    margin-right: 10px;
`;

export const IconFlex = styled.div`
    display: flex;
    align-items: center;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    margin-top: 20px;
`;

export const GoToMyAccount = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    color: #1b73e8;
    margin-top: 16px;
`;

export const GoHomeButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: 32px;
`;
